import React, {useState, useEffect} from 'react';
import getData from '../../Services/GetData';
import Loader from '../../Atoms/Loader/Loader';
import logo from './Assets/logo.jpeg';
import ToTopArrow from '../../Atoms/ToTopArrow/ToTopArrow';
import './Menu1.scss';

const Menu1 = () => {
  const [congressData, setCongressData] = useState();
  const data = congressData && congressData.Brewery;

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
    document.body.classList.add('force-dark', 'no-chat');
    return () => {
      document.body.classList.remove('force-dark', 'no-chat');
    };
  }, []);

  const fetchData = () => {
    getData({
      url: 'https://api.npoint.io/b17e2923754b04c3a2ae'
    }).then(resp => setCongressData(resp.data));
  };

  return(
    <div className='page menu1'>
      <div className='container'>
        <div className='brand-wrapper'>
          <img src={logo} alt="brewery" />
        </div>
        {!congressData ? <Loader /> : (
          <div className='menu-content'>
            <section>
              <span className='section-title'>{data[0].titulo_seccion}</span>
              <ul>
              {data[0].contenido_seccion.map(item =>
                (item.habilitado === 'si' || item.habilitado === 'Si') &&
                <li key={item.id}>
                  <div className='row'>
                    <span className='title'>{item.titulo}</span>
                    <span className='price'>${item.precio}</span>
                  </div>
                  <span className='description'>{item.descripcion}</span>
                  <div className='info'>
                    <span>
                      ABV: {item.ABV}
                    </span>
                    <span>
                      IBU: {item.IBU}
                    </span>
                    <span>
                      SRM: {item.SRM}
                    </span>
                  </div>
                </li>
              )}
            </ul>
            </section>
            <section>
              <span className='section-title'>{data[1].titulo_seccion}</span>
              <ul>
                {data[1].contenido_seccion.map(item =>
                  <li key={item.id}>
                    <div className='row'>
                      <span className='title'>{item.titulo}</span>
                      <span className='price'>${item.precio}</span>
                    </div>
                    <span className='description'>{item.descripcion}</span>
                  </li>
                )}
              </ul>
            </section>
            <section>
            <span className='section-title'>{data[2].titulo_seccion}</span>
            <ul>
              {data[2].contenido_seccion.map(item =>
                <li key={item.id}>
                  <div className='left-wrapper'>
                    <span className='title'>{item.titulo}</span>
                    <span className='description'>{item.descripcion}</span>
                  </div>
                  <div className='right-wrapper'>
                    <div className='prices-wrapper'>
                      <span className='title'>{item.titulo_molde}</span>
                      <span className='price'>${item.precio_molde}</span>
                    </div>
                    <div className='prices-wrapper'>
                      <span className='title'>{item.titulo_piedra}</span>
                      <span className='price'>${item.precio_piedra}</span>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </section>
          <section>
            <span className='section-title'>{data[3].titulo_seccion}</span>
            <ul>
              {data[3].contenido_seccion.map(item =>
                <li key={item.id}>
                  <div className='row'>
                    <span className='title'>{item.titulo}</span>
                    <span className='price'>${item.precio}</span>
                  </div>
                  <span className='description'>{item.descripcion}</span>
                </li>
              )}
            </ul>
          </section>
          <section>
            <span className='section-title'>{data[4].titulo_seccion}</span>
            <ul>
              {data[4].contenido_seccion.map(item =>
                <li key={item.id}>
                  <div className='row'>
                    <span className='title'>{item.titulo}</span>
                    <span className='price'>${item.precio}</span>
                  </div>
                  <span className='description'>{item.descripcion}</span>
                </li>
              )}
            </ul>
          </section>
          <section>
            <span className='section-title'>{data[5].titulo_seccion}</span>
            <ul>
              {data[5].contenido_seccion.map(item =>
                <li key={item.id}>
                  <div className='row'>
                    <span className='title'>{item.titulo}</span>
                    <span className='price'>${item.precio}</span>
                  </div>
                  <span className='description'>{item.descripcion}</span>
                </li>
              )}
            </ul>
          </section>
          </div>
        )}
      </div>
      <ToTopArrow />
    </div>
  );
};

export default Menu1;